import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useAuth } from '../context/AuthContext';

// Field Component moved OUTSIDE to fix keyboard jumping
const Field = ({ label, children, error }) => (
  <div className="flex flex-col gap-1 w-full">
    <label className="text-sm text-gray-400">{label}</label>
    {children}
    {error && <span className="text-xs text-red-500">{error}</span>}
  </div>
);

export default function Register() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { register } = useAuth();
  const [name, setName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [confirm, setConfirm] = useState('');
  const [error, setError] = useState('');
  
  const [showPassword, setShowPassword] = useState(false);
  const [showConfirm, setShowConfirm] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (password !== confirm) return setError('Passwords do not match');
    try {
      await register({ name, email, password });
      navigate('/login');
    } catch (err) {
      setError(err.message || 'Registration failed');
    }
  };

  const inputCls = "w-full bg-[#161b22] border border-gray-700 rounded-lg px-4 py-3 text-white focus:outline-none focus:border-orange-500";

  return (
    <div className="min-h-screen bg-[#0d1117] flex items-center justify-center p-4">
      <div className="w-full max-w-md bg-[#161b22] p-8 rounded-2xl border border-gray-800 shadow-2xl">
        <h2 className="text-2xl font-bold text-white mb-6 text-center">{t('register') || 'Register'}</h2>
        {error && <div className="bg-red-500/10 text-red-500 p-3 rounded mb-4 text-sm">{error}</div>}
        <form onSubmit={handleSubmit} className="flex flex-col gap-4">
          <Field label={t('name_optional') || 'Name (Optional)'}>
            <input type="text" value={name} onChange={(e) => setName(e.target.value)} className={inputCls} />
          </Field>
          <Field label={t('email') || 'Email'}>
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required className={inputCls} />
          </Field>
          <Field label={t('password') || 'Password'}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type={showPassword ? "text" : "password"} value={password} onChange={(e) => setPassword(e.target.value)} required className={inputCls} />
              <button type="button" onClick={() => setShowPassword(!showPassword)} className="text-blue-500 text-sm whitespace-nowrap">
                {showPassword ? "Hide" : "Show"}
              </button>
            </div>
          </Field>
          <Field label={t('confirm_password_label') || 'Confirm Password'}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <input type={showConfirm ? "text" : "password"} value={confirm} onChange={(e) => setConfirm(e.target.value)} required className={inputCls} />
              <button type="button" onClick={() => setShowConfirm(!showConfirm)} className="text-blue-500 text-sm whitespace-nowrap">
                {showConfirm ? "Hide" : "Show"}
              </button>
            </div>
          </Field>
          <button type="submit" className="w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-lg mt-2 transition-colors">
            {t('register') || 'Register'}
          </button>
        </form>
        <p className="text-center text-gray-400 mt-6 text-sm">
          {t('already_have_account') || 'Already have an account?'} <Link to="/login" className="text-orange-500 hover:underline">{t('login') || 'Login'}</Link>
        </p>
      </div>
    </div>
  );
}
